import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import * as routesNames from "../constants/routes";


const EMPLOYEE_MODULE_ROUTES = [
  routesNames.EMPLOYEES,
  routesNames.ADDNEWEMPLOYEE,
];

export const useModuleFilterReset = () => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    const currPath = location.pathname;

    const wasInModule = EMPLOYEE_MODULE_ROUTES.some(r => prevPath.startsWith(r));
    const isInModule = EMPLOYEE_MODULE_ROUTES.some(r => currPath.startsWith(r));

    if (wasInModule && !isInModule) {
      sessionStorage.removeItem("employeeFilter");
    }

    prevPathRef.current = currPath;
  }, [location.pathname]);
};